import { parseISO } from "date-fns";

export const isTimeInRange = (
  value: string,
  timeFrom?: string,
  timeTo?: string
) => {
  if (!timeFrom || !timeTo) {
    return false;
  }

  const time = parseISO(value);
  const from = parseISO(timeFrom);
  const to = parseISO(timeTo);

  const retVal = time >= from && time <= to;
  return retVal;
};
